module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two_b@2x.5f05755c.jpg";